<template>
  <div>
    <el-container>
      <el-header>
        <Header-Bar></Header-Bar>
      </el-header>
      <el-container style="min-height: 90vh;">
        <el-aside width="180px">
          <nav-bar></nav-bar>
        </el-aside>
        <el-main>
<!--          <router-view v-if="isRouterAlive" />-->
          <div class="main-container">
            <tags-view />
          </div>
          <app-main/>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import NavBar from './NavBar'
import HeaderBar from './HeaderBar'
import TagsView from './TagsView/index'
import AppMain from './AppMain'
export default {
  components: {
    AppMain,
    NavBar,
    HeaderBar,
    TagsView
  },
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue